import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {programsService} from "../../../services/programsService/programsService";
import Loader from "../../../components/common/Loader";
import ProgramsList from "./ProgramsList";
import notFound from "../../../assets/not-found/not_found.png";
import {TruncatedHtmlTextContent} from "../../../components/TruncatedHtmlTextContent/TruncatedHtmlTextContent";

const InstitutionUserPrograms = () => {
    const [programs, setPrograms] = useState([]);
    const [recommendations, setRecommendations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setIsLoading(true);
        getAllPrograms();
    }, []);

    const getAllPrograms = async () => {
        try {
            const response = await programsService.getPrograms();

            setPrograms(response.data['programs']);
            setRecommendations(response.data['recommendations']);

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    const handleRecommendationNavigate = (id) => {
        navigate(`/programs/${id}/preview`);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <>
            <div className="container-fluid">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="d-lg-block d-none">Programs</h3>
                </div>
                {isLoading ? (
                    <Loader />
                ) : (
                    <div>
                        {programs.length > 0 && (
                            <>
                                <ProgramsList programs={programs} />
                            </>
                        )}
                        {programs?.length === 0 && (
                            <div className="w-100 mt-3 rounded-4 text-center d-flex flex-column align-items-center justify-content-center" style={{ height: "500px" }}>
                                <img crossOrigin="anonymous" src={notFound} alt="data not found" width={300} />
                                <h3>No Programs Added</h3>
                                <p className="fs-5">No programs available at the moment.</p>
                            </div>
                        )}
                    </div>
                )}
                {isLoading ? (
                    <Loader />
                ) : (
                    <div>
                        {recommendations.length > 0 && (
                            <>
                                <h3 className="d-lg-block mt-3">Recommendations</h3>
                                <div className="row">
                                    {recommendations?.map((program) => {
                                        return (
                                            <React.Fragment key={program.id}>
                                                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6 col-12 position-relative">
                                                    <div
                                                        className={`card text-white m-3 p-4 program-masterclass-card rounded-3 ${
                                                            program?.is_completed ? "overlay-completed master-class-completed-opacity" : ""
                                                        }`} onClick={() => handleRecommendationNavigate(program?.id)}>
                                                        <img src={program?.cover_image}
                                                             className="card-img-top program-masterclass-card-thumbnail img-fluid rounded-3 mb-3"
                                                             alt={program?.name}/>
                                                        <h5 className="card-title mb-3">{program?.name}</h5>
                                                        <div className="mb-3">
                                                            <TruncatedHtmlTextContent
                                                                text={program?.description}
                                                                lineClamp={2}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default InstitutionUserPrograms;